import { queryOptions } from '@tanstack/react-query';
import type { DefaultApiParams } from '@/std/pagination/types';
import { fetchApi } from '@/std/api/fetchApi';
import { registrosSchema } from '@/std/schema';
import { TabelaComissaoSchema } from '../types/TabelaComissao';

export type TabelaComissaoConsultarParams = Partial<DefaultApiParams & { descricao: string }>;

const schema = registrosSchema(TabelaComissaoSchema);

function apiTabelaComissaoConsultar(params?: TabelaComissaoConsultarParams, idpk?: number) {
    return fetchApi({
        endpoint: 'TabelaComissao/Consultar',
        idpk,
        method: 'get',
        params,
        schema,
    });
}

export const API_TABELA_COMISSAO_CONSULTAR_KEY = 'apiTabelaComissaoConsultar';

export function apiTabelaComissaoConsultarQueryOptions({
    idpk,
    params,
}: {
    idpk?: number;
    params?: TabelaComissaoConsultarParams;
} = {}) {
    return queryOptions({
        queryFn: () => apiTabelaComissaoConsultar(params, idpk),
        queryKey: [API_TABELA_COMISSAO_CONSULTAR_KEY, { idpk, params }],
    });
}
